export const getErrorMessageByType = (error: any) => {
  let message = '';
  switch (error?.code) {
    default:
      message = 'Algo salió mal, por favor intente de nuevo.';
      break;
  }
  return message;
};
